export default "__VITE_ASSET__CkHPcZ_S__"